<template>
    <v-alert
        v-model="value"
        close-text="Close Alert"
        dismissible
        :class="classes"
        :icon="`mdi-${icon}`"
    >
        <div class="header5">{{ title }}</div>
        <div class="body-text" v-if="message">{{ message }}</div>

        <!-- is this really necessary? -->
        <template #close>
            <v-icon @click="close" class="notification-close">mdi-close</v-icon>
        </template>
    </v-alert>
</template>

<script>
import {mapActions} from "pinia";
import _ from "lodash";
import DialogMixin from "@/Shared/Dialogs/DialogMixin";
import {DISMISSIBLE_IN, toast} from "@/Store/toast";

const validTypes = ['info', 'success', 'error', 'warning'];

const iconTypeMap = {
    info: 'information-variant',
    success: 'check',
    error: 'window-close',
    warning: 'exclamation',
};

export default {
    mixins: [DialogMixin],

    props: {
        type: {
            type: String,
            default: 'info',
            validator: value => validTypes.inArray(value),
        },

        title: {
            type: String,
            require: true,
        },

        message: {
            type: String,
        },

        filled: {
            type: Boolean,
            default: true,
        },

        dismissible: {
            type: Boolean,
            default: true,
        },

        dismissibleIn: {
            type: Number,
            default: DISMISSIBLE_IN,
        },
    },

    data: () => ({
        handler: null
    }),

    methods: {
        onClose() {
            this.shift();
        },

        ...mapActions(toast, [
            'shift',
        ])
    },

    computed: {
        icon() {
            return _.get(iconTypeMap, this.type, 'information-variant');
        },

        classes() {
            let classes = [
                `notify-${this.type}`,
                'notification',
            ];

            if (this.filled) {
                classes.push('filled');
            }

            return classes;
        },
    },

    mounted() {
        if (this.dismissibleIn > 0) {
            this.handler = setTimeout(() => {
                this.close();
            }, this.dismissibleIn)
        }
    },

    beforeDestroy() {
        clearTimeout(this.handler);
    },
}
</script>

<style>

</style>
